/**
 * Config
 */
const env =
  window.location.hostname.match(/(^|\.)serverless\.com$/) ||
  import.meta.env.REACT_APP_ENV === 'prod'
    ? 'prod'
    : 'dev'
/**
 * Dev
 */
const devConfig = {
  host: 'https://www.serverless-dev.com',
  localStorageKey: 'serverless-dev',
  auth0: {
    domain: 'auth.serverless-dev.com',
    clientId: 'EMAtx5b2Bf3PB94c3pm9nrADxpFvyZcm',
    audience: 'https://serverlessdev.auth0.com/userinfo',
    scope: 'openid email_verified email profile name offline_access',
  },
  platform: {
    stage: 'dev',
    apiUrl: 'https://api.serverless-dev.com',
    integrationsBase: 'https://integrations.core.serverless-dev.com/api',
    coreApiUrl: 'https://core.serverless-dev.com/api',
    sp: 'https://sp-providers-v1.serverless-platform-dev.com',
    integrationsUrl: 'https://integrations.core.serverless-dev.com/api/integrations',
    alerts: 'https://alerts-api.core.serverless-dev.com/v1',
  },
  stripe: {
    apiKey: 'pk_test_q68RE9RoItF3A3c9Qx903A0Y004VeuwvWj',
  },
  mui: {
    licenseKey:
      'e7163c4816a16be174ebb724c5c5590aTz04OTQ3MixFPTE3NDYxMTI4MTQwMDAsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI=',
  },
  // Hotjar tracking site id and Hotjar Snippet Version
  hotjar: {
    hjid: '3478034',
    hjsv: '6',
  },
  /**
   * NOTE: AWS provides both a product id and product code. They're two different things
   * used in different scenarios/APIs, but they both uniquely identify a product.
   */
  aws: {
    subscriptionUrl: 'https://aws.amazon.com/marketplace/saas/ordering',
    products: {
      latest: {
        id: 'prod-uasomcg6ggpss',
        code: 'bqqfeu0k39yxk6wzzt4vm90n3',
      },
      legacyWithOverage: {
        id: 'prod-godrvp4nbekk2',
        code: '4ngbjugmvif5oifo7cddhnldi',
      },
      legacy: {
        id: 'prod-fkgmx7zmbkhts',
        code: '9fq9dq0td8xjhvtdimccx0keo',
      },
    },
  },
  calendly: 'https://slss.io/meet ', // link for users to set up a meeting
  contact: {
    support: 'support@serverless.com',
  },
}

/**
 * Prod
 */
const prodConfig = {
  host: 'https://www.serverless.com',
  localStorageKey: 'serverless',
  auth0: {
    domain: 'auth.serverless.com',
    clientId: 'YAHOG8papb1tkrLttNVoVOSs4YLOjrNj',
    audience: 'https://serverlessinc.auth0.com/userinfo',
    scope: 'openid email_verified email profile name offline_access',
  },
  platform: {
    stage: 'prod',
    apiUrl: 'https://api.serverless.com',
    integrationsBase: 'https://integrations.core.serverless.com/api',
    coreApiUrl: 'https://core.serverless.com/api',
    sp: 'https://sp-providers-v1.serverless-platform.com',
    integrationsUrl: 'https://integrations.core.serverless.com/api/integrations',
    alerts: 'https://alerts-api.core.serverless.com/v1',
  },
  stripe: {
    apiKey: 'pk_live_fUrnuMKodQM6UMXPZnFcNQ3N002icn5R5D',
  },
  mui: {
    licenseKey:
      'e7163c4816a16be174ebb724c5c5590aTz04OTQ3MixFPTE3NDYxMTI4MTQwMDAsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI=',
  },

  // Hotjar tracking site id and Hotjar Snippet Version
  hotjar: {
    hjid: '3476560',
    hjsv: '6',
  },
  /**
   * NOTE: AWS provides both a product id and product code. They're two different things
   * used in different scenarios/APIs, but they both uniquely identify a product.
   */
  aws: {
    subscriptionUrl: 'https://aws.amazon.com/marketplace/saas/ordering',
    products: {
      latest: {
        id: 'prod-2vpeqnu2vqifa',
        code: '7k1t0lnlb2ixcn05ap8ye1n3z',
      },
      legacyWithOverage: {
        id: 'prod-ldknvn4qm5rcc',
        code: 'c4b9tz2we495pwzdqxt3l79yi',
      },
      legacy: {
        id: 'prod-frvpmlhwbjj5o',
        code: '773mnnepvyucj2ha3lo343kbd',
      },
    },
  },
  calendly: 'https://slss.io/meet',
  contact: {
    support: 'support@serverless.com',
  },
}

export default env === 'prod' ? prodConfig : devConfig
